export class LangConstant {
  static LANG_KR = "kr";
}